module.exports = __webpack_public_path__ + "media/images/preview_training_2_thumb-f288e927c0dc6a05b8bb1f32a68c91f1.webp";